/* eslint-disable no-unused-vars, no-console, react/jsx-indent-props,react/jsx-wrap-multilines, no-undef, react/jsx-closing-bracket-location */

import { InfiniteStoryBase, WithPreview, refreshDfpAds } from "@quintype/components";
import "array-flat-polyfill";
import get from "lodash/get";
import { array, func, object, string } from "prop-types";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setBookmark, setStoryHeader } from "../helper/actions";
import { getBookmarkByPageId } from "../helper/api";
import BlankStory from "../story-templates/blank";
import LiveBlog from "../story-templates/liveBlog";
import PhotoStory from "../story-templates/photo";
import VideoStory from "../story-templates/Video";
import { googleTagEvents } from "../utils/utils";

import "./story.m.css";

export function StoryPageBase({ story, relatedStories }) {
  let summaryText;
  let startingCard = 0;
  const summaryMeta = get(story, ["metadata", "summary"], "");

  if (summaryMeta) {
    summaryText = `<p>${summaryMeta}</p>`;
  } else {
    const firstCard = get(story, ["cards", "0", "story-elements"]);
    const summaryElement = firstCard.filter((item) => item.subtype === "summary");
    summaryText = get(summaryElement, ["0", "text"], "");
    startingCard = summaryText.length && 1;
  }

  const imageElements = story.cards
    .map((card) => card["story-elements"].filter((item) => item && item.type === "image"))
    .flat();

  switch (story["story-template"]) {
    case "live-blog":
      return (
        <div styleName="story-page-wrapper">
          <LiveBlog story={story} imageElements={imageElements} />
        </div>
      );
    case "video":
      return (
        <div styleName="story-page-wrapper">
          <VideoStory story={story} relatedStories={relatedStories} summary={summaryText} />
        </div>
      );
    case "photo":
      return (
        <div styleName="story-page-wrapper">
          <PhotoStory
            story={story}
            relatedStories={relatedStories}
            summary={summaryText}
            imageElements={imageElements}
          />
        </div>
      );
    case "gallery":
      return (
        <div styleName="story-page-wrapper">
          <PhotoStory
            story={story}
            relatedStories={relatedStories}
            summary={summaryText}
            imageElements={imageElements}
          />
        </div>
      );
    default:
      return (
        <div styleName="story-page-wrapper">
          <BlankStory
            story={story}
            relatedStories={relatedStories}
            summary={summaryText}
            imageElements={imageElements}
            startingCard={startingCard}
          />
        </div>
      );
  }
}

StoryPageBase.propTypes = {
  story: object,
  relatedStories: array,
};

const FIELDS =
  "id,authors,headline,subheadline,slug,hero-image-s3-key,hero-image-metadata,published-at,first-published-at,last-published-at,alternative,author-name,author-id,sections,story-template,cards,url,tags,metadata,linked-story-ids";

function storyPageLoadItems(pageNumber, relatedStories, sectionId) {
  return global
    .wretch(`/api/v1/advanced-search`)
    .query({
      fields: FIELDS,
      limit: 1,
      type: "text,photo,gallery,live-blog",
      "section-id": sectionId,
      sort: "latest-published",
    })
    .get()
    .json((response) =>
      response.items.map((item) => {
        return { story: item, otherProp: "value", relatedStories };
      })
    );
}

const micrositesBrandNames = {
  muktijuddho: "চিরন্তন ১৯৭১",
};

const brandTitle = (config) => {
  const brandTitle = config["publisher-settings"].title;
  const brandTitleFallback = config["sketches-host"].includes("en") ? "Prothom Alo" : "প্রথম আলো";
  return brandTitle || brandTitleFallback;
};

const StoryPageView = (props) => {
  useEffect(() => {
    if (props.jwtToken) {
      getBookmarkByPageId(props.metypeConfig, props.data.story.url, props.jwtToken)
        .then((data) => props.setBookmark(data))
        .catch(() => props.setBookmark(null));
    }
  }, [props.jwtToken]);

  useEffect(() => {
    const headerElement = global.document.getElementById("top-ad");
    if (headerElement) {
      headerElement.style.cssText = "min-height: 0";
    }
  }, []);

  props.data.story["story-template"] === "video" &&
    props.setStoryHeader({
      headline: props.data.story.headline,
      section: props.data.story.sections[0]["display-name"],
      slug: props.data.story.slug,
      sectionUrl: props.data.story.sections[0]["section-url"],
      url: props.data.story.url,
      story: props.data.story,
    });

  const sectionId = get(props, ["data", "story", "sections", "0", "id"]);
  // NTG
  const [scroll, setScroll] = useState(0);
  const scrollEventTrigger = (value, pageTitle) => {
    googleTagEvents("article-milestone", pageTitle, value);
  };
  useEffect(() => {
    const scrollCalculate = () => {
      const scrollTop = window.scrollY;
      const docHeight = document.body.offsetHeight;
      const winHeight = window.innerHeight;
      const scrollPercent = scrollTop / (docHeight - winHeight);
      const scrollPercentRounded = Math.round(scrollPercent * 100);
      if (scrollPercentRounded >= 25 && scrollPercentRounded < 50) {
        if (scroll < 25) {
          setScroll(25);
          scrollEventTrigger(25, `${props.data.story.headline}`);
        }
      } else if (scrollPercentRounded >= 50 && scrollPercentRounded < 75) {
        if (scroll < 50) {
          setScroll(50);
          scrollEventTrigger(50, `${props.data.story.headline}`);
        }
      } else if (scrollPercentRounded >= 75 && scrollPercentRounded < 90) {
        if (scroll < 75) {
          setScroll(75);
          scrollEventTrigger(75, `${props.data.story.headline}`);
        }
      } else if (scrollPercentRounded >= 90) {
        if (scroll < 90) {
          setScroll(90);
          scrollEventTrigger(100, `${props.data.story.headline}`);
        }
      }
    };
    if (window) {
      window.addEventListener("scroll", scrollCalculate);
      return () => {
        window.removeEventListener("scroll", scrollCalculate);
      };
    }
  }, [scroll]);

  return props.data.story["story-template"] === "video" ? (
    <React.Fragment>
      <StoryPageBase story={props.data.story} relatedStories={props.data.relatedStories} />
    </React.Fragment>
  ) : (
    <React.Fragment>
      <InfiniteStoryBase
        {...props}
        render={StoryPageBase}
        loadItems={(pageNumber) => storyPageLoadItems(pageNumber, props.data.relatedStories, sectionId)}
        neverHideItem={true}
        onInitialItemFocus={(item) =>
          app.registerPageView({ pageType: "story-page", data: { story: item.story } }, `/${item.story.slug}`)
        }
        onItemFocus={(item, index) => {
          const seoObj = get(item, ["story", "seo"], {});
          const brandName = props.domainSlug ? micrositesBrandNames[props.domainSlug] : brandTitle(props.config);
          const title =
            seoObj && seoObj["meta-title"]
              ? `${seoObj["meta-title"]} | ${brandName}`
              : `${item.story.headline} | ${brandName}`;
          // Check if story is bookmarked
          getBookmarkByPageId(props.metypeConfig, item.story.url, props.jwtToken)
            .then((data) => props.setBookmark(data))
            .catch(() => props.setBookmark(null))
            .finally(() => {
              props.setStoryHeader({
                headline: item.story.headline,
                section: item.story.sections[0]["display-name"],
                slug: item.story.slug,
                sectionUrl: item.story.sections[0]["section-url"],
                url: item.story.url,
                story: item.story,
                id: item.story.id,
                tags: item.story.tags,
                sections: item.story.sections,
                "story-template": item.story["story-template"],
                storyIndex: index,
              });
              // Check anchor ads open or not & refresh
              const anchorAdsContainer = document.getElementsByClassName("ad-bottom-container");
              if (anchorAdsContainer && anchorAdsContainer[0] && anchorAdsContainer[0].className.includes("show-ad")) {
                refreshDfpAds("breaking-news-slider-ad");
              }
            });
        }}
        metypeConfig={props.metypeConfig}
      />
    </React.Fragment>
  );
};

StoryPageView.propTypes = {
  data: object,
  setStoryHeader: func,
  setBookmark: func,
  jwtToken: string,
  metypeConfig: object,
  publisherAttributes: object,
  domainSlug: string,
  config: object,
};

const mapDispatchToProps = (dispatch) => ({
  setStoryHeader: (storyHeaderObj) => dispatch(setStoryHeader(storyHeaderObj)),
  setBookmark: (bookmarkObj) => dispatch(setBookmark(bookmarkObj)),
});

export const StoryPagePreview = WithPreview(StoryPageView, (data, story) =>
  Object.assign({}, data, {
    story,
    relatedStories: Array(5).fill(story),
  })
);

const mapStateToProps = (state) => ({
  domainSlug: get(state, ["qt", "domainSlug"], ""),
  jwtToken: get(state, ["userReducer", "jwt_token"], null),
  metypeConfig: get(state, ["qt", "config", "publisher-attributes", "metypeConfig"], {}),
  config: get(state, ["qt", "config"], {}),
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export const StoryPage = connect(mapStateToProps, mapDispatchToProps)(StoryPageView);
